/* RIPOST · /products : instant search + filters over the full catalog (client side). Safari 15+, no dependencies.
   The grid is server-rendered and paginated (works without JS). On first interaction (or when the URL carries filters) the other
   pages are fetched with the Section Rendering API and every card is kept in memory; filtering only shows/hides/reorders cards.
   URL state (replaceState): ?q= &type= &compat=u|s &brand= &min= &max= &stock=1 &sort=new|pa|pd|az &bike=1. Canonical stays /products. */
(function () {
'use strict';
var root = document.querySelector('[data-rap]');
var cfgEl = document.getElementById('rap-config');
if (!root || !cfgEl) return;
var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
var $ = function (s, r) { return (r || root).querySelector(s); };
var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
var html = document.documentElement;
var grid = $('[data-rap-grid]'), qi = $('[data-rap-q]'), qc = $('[data-rap-qc]'), sortEl = $('[data-rap-sort]'), countEl = $('[data-rap-count]');
var actEl = $('[data-rap-act]'), noteEl = $('[data-rap-note]'), emptyEl = $('[data-rap-empty]'), moreEl = $('[data-rap-more]'), pgEl = $('[data-rap-pg]');
var fEl = $('[data-rap-f]'), backEl = $('[data-rap-back]'), openBtn = $('[data-rap-open]'), fnEl = $('[data-rap-fn]'), mineEl = $('[data-rap-mine]');
var minEl = $('[data-rap-min]'), maxEl = $('[data-rap-max]');
var STEP = cfg.perPage || 24;
var nf = function (s) { return String(s == null ? '' : s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); };
var esc = function (v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
var eur = function (c) { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: c % 100 ? 2 : 0 }).format(c / 100); };
var typeLabel = {}, brandLabel = {}, brandHay = {};
cfg.types.forEach(function (t) { typeLabel[t.c] = t.l; });
cfg.brands.forEach(function (b) { brandLabel[b.h] = b.l; brandHay[b.h] = nf(b.l + ' ' + b.h.replace(/-/g, ' ')); });

var items = [], byHandle = {}, allLoaded = false, loadingAll = null, bikes = null, loadingBikes = null, shown = STEP;
var serverEls = [];
var state = { q: '', types: [], compat: '', brands: [], min: null, max: null, stock: false, sort: 'rel', mine: false };

/* ---------- items ---------- */
function readItem(el, page, idx) {
  var d = el.dataset, c = (d.c || '').split(',').filter(Boolean), b = (d.b || '').split(',').filter(Boolean), u = d.u === '1';
  var it = { el: el, h: d.h, t: d.t || '', p: +d.p || 0, a: d.a === '1', d: +d.d || 0, c: c, b: b, u: u, s: !u && (b.length > 0 || /^adapt\b/i.test(d.t || '')), i: page * 1000 + idx, bikes: [], page: page, tl: nf(d.t || '') };
  it.base = nf([d.t, c.map(function (x) { return typeLabel[x] || x; }).join(' '), b.map(function (x) { return brandLabel[x] || x; }).join(' '), u ? 'universel compatible tous les velos' : ''].join(' '));
  it.hay = it.base;
  return it;
}
function register(it) { if (byHandle[it.h]) return false; byHandle[it.h] = it; items.push(it); return true; }
$$('.rap__it', grid).forEach(function (el, i) { var it = readItem(el, cfg.page, i); if (register(it)) serverEls.push(el); });

function ensureAll() {
  if (allLoaded) return Promise.resolve();
  if (loadingAll) return loadingAll;
  var jobs = [];
  for (var n = 1; n <= cfg.pages; n++) if (n !== cfg.page) jobs.push(n);
  loadingAll = Promise.all(jobs.map(function (n) {
    var u = location.pathname + '?section_id=' + encodeURIComponent(cfg.sectionId) + '&page=' + n;
    return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw Error(r.status); return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html');
      Array.prototype.forEach.call(doc.querySelectorAll('.rap__it'), function (el, i) { register(readItem(el, n, i)); });
    });
  })).then(function () { allLoaded = items.length >= cfg.total; if (!allLoaded) throw Error('incomplete'); items.sort(function (a, b) { return a.i - b.i; }); enrich(); })
    .catch(function (e) { loadingAll = null; throw e; });
  return loadingAll;
}
function ensureBikes() {
  if (bikes) return Promise.resolve();
  if (loadingBikes) return loadingBikes;
  loadingBikes = fetch(cfg.rbf, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw Error(r.status); return r.json(); }).then(function (d) {
    bikes = (d.bikes || []).map(function (b) { return { h: b.h, b: b.b, m: b.m, l: (b.b + ' ' + b.m + (b.v ? ' ' + b.v : '') + (b.l ? ' ' + b.l : '') + ' ' + (b.y1 || '') + ' ' + (b.y2 || '')), name: b.b + ' ' + b.m + (b.v ? ' ' + b.v : '') + (b.y1 ? ' ' + b.y1 + (b.y2 ? (String(b.y1) === String(b.y2) ? '' : '–' + b.y2) : '+') : (b.y2 ? ' –' + b.y2 : '')), url: b.url, ph: b.ph || [], hay: nf(b.b + ' ' + b.m + ' ' + (b.v || '') + ' ' + (b.l || '') + ' ' + (b.y1 || '') + ' ' + (b.y2 || '')) }; });
    enrich();
  }).catch(function (e) { loadingBikes = null; bikes = null; throw e; });
  return loadingBikes;
}
function enrich() {
  items.forEach(function (it) { it.hay = it.base; it.bikes = []; });
  if (!bikes) return;
  bikes.forEach(function (b) { b.ph.forEach(function (h) { var it = byHandle[h]; if (it) { it.bikes.push(b.h); it.hay += ' ' + b.hay; if (!it.u && !it.s) it.s = true; } }); });
}
function ensure() { return Promise.all([ensureAll(), ensureBikes().catch(function () {})]); }

/* ---------- state <-> URL ---------- */
function parseUrl() {
  var p = new URLSearchParams(location.search), s = { q: (p.get('q') || '').slice(0, 80), types: [], compat: '', brands: [], min: null, max: null, stock: false, sort: 'rel', mine: false };
  (p.get('type') || '').split(',').forEach(function (c) { if (typeLabel[c] && s.types.indexOf(c) < 0) s.types.push(c); });
  (p.get('brand') || '').split(',').forEach(function (c) { if (brandLabel[c] && s.brands.indexOf(c) < 0) s.brands.push(c); });
  if (p.get('compat') === 'u' || p.get('compat') === 's') s.compat = p.get('compat');
  if (p.get('min') !== null && p.get('min') !== '' && !isNaN(+p.get('min'))) s.min = Math.max(0, +p.get('min'));
  if (p.get('max') !== null && p.get('max') !== '' && !isNaN(+p.get('max'))) s.max = Math.max(0, +p.get('max'));
  s.stock = p.get('stock') === '1'; s.mine = p.get('bike') === '1';
  if (['new', 'pa', 'pd', 'az'].indexOf(p.get('sort')) >= 0) s.sort = p.get('sort');
  return s;
}
function isDefault(s) { return !s.q && !s.types.length && !s.compat && !s.brands.length && s.min === null && s.max === null && !s.stock && !s.mine && s.sort === 'rel'; }
function writeUrl() {
  var p = new URLSearchParams();
  if (state.q) p.set('q', state.q);
  if (state.types.length) p.set('type', state.types.join(','));
  if (state.compat) p.set('compat', state.compat);
  if (state.brands.length) p.set('brand', state.brands.join(','));
  if (state.min !== null) p.set('min', state.min);
  if (state.max !== null) p.set('max', state.max);
  if (state.stock) p.set('stock', '1');
  if (state.mine) p.set('bike', '1');
  if (state.sort !== 'rel') p.set('sort', state.sort);
  if (isDefault(state) && cfg.page > 1) p.set('page', cfg.page);
  var qs = p.toString(), url = location.pathname + (qs ? '?' + qs : '') + location.hash;
  try { history.replaceState(null, '', url); } catch (e) {}
}
function syncInputs() {
  qi.value = state.q; qc.hidden = !state.q; sortEl.value = state.sort;
  $$('input[name=type]').forEach(function (i) { i.checked = state.types.indexOf(i.value) >= 0; });
  $$('input[name=brand]').forEach(function (i) { i.checked = state.brands.indexOf(i.value) >= 0; });
  $$('input[name=compat]').forEach(function (i) { i.checked = i.value === state.compat; });
  $('input[name=stock]').checked = state.stock;
  minEl.value = state.min === null ? '' : state.min; maxEl.value = state.max === null ? '' : state.max;
  var m = $('[data-rap-mine-in]'); if (m) m.checked = state.mine;
}

/* ---------- matching ---------- */
function tokens(q) { return nf(q).split(/[^a-z0-9]+/).filter(function (t) { return t.length > 0; }); }
function queryInfo() {
  var tk = tokens(state.q), info = { tk: tk, bikeSet: null, brandSet: null, intent: false, bikes: [] };
  if (!tk.length) return info;
  if (bikes) { info.bikes = bikes.filter(function (b) { return tk.every(function (t) { return b.hay.indexOf(t) >= 0; }); }); if (info.bikes.length) { info.bikeSet = {}; info.bikes.forEach(function (b) { info.bikeSet[b.h] = 1; }); info.intent = true; } }
  var bs = cfg.brands.filter(function (b) { return tk.every(function (t) { return brandHay[b.h].indexOf(t) >= 0; }); });
  if (bs.length) { info.brandSet = {}; bs.forEach(function (b) { info.brandSet[b.h] = 1; }); info.intent = true; }
  return info;
}
function passQ(it, q) {
  if (!q.tk.length) return true;
  if (q.tk.every(function (t) { return it.hay.indexOf(t) >= 0; })) return true;
  if (q.intent) {
    if (it.u) return true;
    if (q.bikeSet && it.bikes.some(function (h) { return q.bikeSet[h]; })) return true;
    if (q.brandSet && it.b.some(function (h) { return q.brandSet[h]; })) return true;
  }
  return false;
}
function active() { if (!window.RipostBikes) return null; try { return window.RipostBikes.active(); } catch (e) { return null; } }
function mineSet() { var a = active(); if (!a || !bikes) return null; var b = bikes.filter(function (x) { return x.h === a.handle; })[0]; if (!b) return null; var s = {}; b.ph.forEach(function (h) { s[h] = 1; }); return s; }
function pass(it, q, ms, skip) {
  if (!passQ(it, q)) return false;
  if (skip !== 'type' && state.types.length && !it.c.some(function (c) { return state.types.indexOf(c) >= 0; })) return false;
  if (skip !== 'compat' && state.compat === 'u' && !it.u) return false;
  if (skip !== 'compat' && state.compat === 's' && !it.s) return false;
  if (skip !== 'brand' && state.brands.length && !(it.b.some(function (b) { return state.brands.indexOf(b) >= 0; }) || (it.u && state.compat !== 's'))) return false;
  if (state.min !== null && it.p < state.min * 100) return false;
  if (state.max !== null && it.p > state.max * 100) return false;
  if (skip !== 'stock' && state.stock && !it.a) return false;
  if (state.mine && ms && !(it.u || ms[it.h])) return false;
  return true;
}

/* ---------- render ---------- */
function sortList(list, q) {
  var s = state.sort;
  if (s === 'new') list.sort(function (a, b) { return b.d - a.d || a.i - b.i; });
  else if (s === 'pa') list.sort(function (a, b) { return a.p - b.p || a.i - b.i; });
  else if (s === 'pd') list.sort(function (a, b) { return b.p - a.p || a.i - b.i; });
  else if (s === 'az') list.sort(function (a, b) { return a.tl.localeCompare(b.tl, 'fr') || a.i - b.i; });
  else if (q.intent || state.mine) list.sort(function (a, b) { return (b.u ? 0 : 1) - (a.u ? 0 : 1) || a.i - b.i; });
  else list.sort(function (a, b) { return a.i - b.i; });
  return list;
}
function filterCount() { return state.types.length + (state.compat ? 1 : 0) + state.brands.length + (state.min !== null || state.max !== null ? 1 : 0) + (state.stock ? 1 : 0) + (state.mine ? 1 : 0); }
function chips() {
  var out = [];
  var add = function (k, l) { out.push('<button type="button" class="rap__chip" data-rm="' + esc(k) + '">' + esc(l) + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg><span class="rap__vh">Retirer ce filtre</span></button>'); };
  if (state.q) add('q', 'Recherche : ' + state.q);
  state.types.forEach(function (c) { add('type:' + c, typeLabel[c]); });
  if (state.compat) add('compat', state.compat === 'u' ? 'Universel' : 'Spécifique à un vélo');
  state.brands.forEach(function (h) { add('brand:' + h, 'Compatible ' + brandLabel[h]); });
  if (state.min !== null || state.max !== null) add('price', 'Prix : ' + (state.min !== null ? 'dès ' + state.min + ' €' : '') + (state.min !== null && state.max !== null ? ' ' : '') + (state.max !== null ? 'jusqu’à ' + state.max + ' €' : ''));
  if (state.stock) add('stock', 'En stock');
  if (state.mine) { var a = active(); add('mine', 'Compatible avec ' + (a ? a.label.split(' · ')[0] : 'mon vélo')); }
  if (out.length) out.push('<button type="button" class="rap__clr" data-rap-clear>Tout effacer</button>');
  actEl.hidden = !out.length; actEl.innerHTML = out.join('');
}
function updateCounts(q, ms) {
  $$('[data-count]').forEach(function (el) {
    var k = el.dataset.count.split(':'), f = k[0], v = k[1], n = 0;
    items.forEach(function (it) {
      if (!pass(it, q, ms, f)) return;
      if (f === 'type') { if (it.c.indexOf(v) >= 0) n++; }
      else if (f === 'brand') { if (it.b.indexOf(v) >= 0 || (it.u && state.compat !== 's')) n++; }
      else if (f === 'compat') { if (v === 'u' ? it.u : it.s) n++; }
      else if (f === 'stock') { if (it.a) n++; }
    });
    el.textContent = allLoaded ? n : '';
    var row = el.closest('.rap__o'); if (row) row.classList.toggle('is-zero', allLoaded && n === 0);
  });
}
function renderMine() {
  var a = active();
  if (!window.RipostBikes) { mineEl.hidden = true; return; }
  if (!a) {
    if (state.mine) { state.mine = false; change(); }
    mineEl.hidden = false;
    mineEl.innerHTML = '<span class="rap__mp">Vous avez un vélo ?</span><button type="button" class="rap__ml" data-rbf-open="products">Choisir mon vélo pour voir les produits compatibles</button>';
    return;
  }
  var known = !bikes || bikes.some(function (b) { return b.h === a.handle; });
  mineEl.hidden = false;
  mineEl.innerHTML = '<label class="rap__sw"><input type="checkbox" data-rap-mine-in' + (state.mine ? ' checked' : '') + (known ? '' : ' disabled') + '><i aria-hidden="true"></i><span>Compatible avec mon vélo : ' + esc(a.label.split(' · ')[0]) + '</span></label>' + (known ? '' : '<span class="rap__mp">Ce vélo n’est plus au catalogue.</span>');
}
var rendering = 0;
function render(opts) {
  opts = opts || {};
  var def = isDefault(state);
  if (def || allLoaded) html.classList.remove('rap-pending');
  syncInputs(); writeUrl(); chips();
  var n = filterCount(); fnEl.hidden = !n; fnEl.textContent = n; openBtn.setAttribute('aria-label', 'Filtres' + (n ? ' (' + n + ' actif' + (n > 1 ? 's' : '') + ')' : ''));
  if (def) {
    /* back to the server-rendered page */
    grid.replaceChildren.apply(grid, serverEls);
    pgEl && (pgEl.hidden = false); moreEl.hidden = true; emptyEl.hidden = true; noteEl.hidden = true;
    countEl.textContent = cfg.total + ' produit' + (cfg.total > 1 ? 's' : '');
    if (allLoaded) updateCounts(queryInfo(), mineSet());
    return;
  }
  if (!allLoaded) { countEl.textContent = 'Chargement du catalogue…'; return; }
  var q = queryInfo(), ms = mineSet();
  var list = items.filter(function (it) { return pass(it, q, ms); });
  sortList(list, q);
  var vis = list.slice(0, shown);
  grid.replaceChildren.apply(grid, vis.map(function (it) { return it.el; }));
  pgEl && (pgEl.hidden = true);
  moreEl.hidden = list.length <= shown;
  if (!moreEl.hidden) $('[data-rap-showmore]').textContent = 'Afficher plus de produits (' + Math.min(shown, list.length) + ' sur ' + list.length + ')';
  emptyEl.hidden = list.length > 0;
  countEl.textContent = list.length === 0 ? 'Aucun produit' : (list.length === items.length ? list.length : list.length + ' sur ' + items.length) + ' produit' + (list.length > 1 ? 's' : '');
  /* note: bike intent summary */
  var nu = list.filter(function (it) { return it.u; }).length, ns = list.length - nu, note = '';
  if (q.intent && list.length) {
    var named = q.bikes.slice(0, 5).map(function (b) { return '<a href="' + esc(b.url) + '">' + esc(b.name) + '</a>'; }).join(', ');
    note = '<strong>' + ns + ' produit' + (ns > 1 ? 's' : '') + ' spécifique' + (ns > 1 ? 's' : '') + '</strong> et <strong>' + nu + ' universel' + (nu > 1 ? 's' : '') + '</strong> pour « ' + esc(state.q) + ' ».' + (named ? ' Pages vélo : ' + named + (q.bikes.length > 5 ? '…' : '') + '.' : '');
  } else if (state.mine && list.length) {
    var a = active(); note = '<strong>' + ns + ' produit' + (ns > 1 ? 's' : '') + ' ADAPT</strong> pour votre ' + esc(a ? a.label.split(' · ')[0] : 'vélo') + ' et <strong>' + nu + ' universel' + (nu > 1 ? 's' : '') + '</strong>.' + (a && a.url ? ' <a href="' + esc(a.url) + '">Voir la page de ce vélo</a>' : '');
  }
  noteEl.hidden = !note; noteEl.innerHTML = note;
  updateCounts(q, ms);
}
var timer = 0;
function change(opts) {
  shown = STEP;
  if (isDefault(state)) { render(); return; }
  render();
  ensure().then(function () { render(); }).catch(function () { fail(); });
}
function fail() {
  html.classList.remove('rap-pending');
  countEl.textContent = 'Le catalogue complet n’a pas pu être chargé. Rechargez la page ou utilisez la pagination.';
}

/* ---------- events ---------- */
qi.addEventListener('input', function () { qc.hidden = !qi.value; clearTimeout(timer); timer = setTimeout(function () { state.q = qi.value.trim().slice(0, 80); change(); }, 120); });
qi.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); clearTimeout(timer); state.q = qi.value.trim().slice(0, 80); change(); } if (e.key === 'Escape' && qi.value) { e.preventDefault(); qi.value = ''; state.q = ''; qc.hidden = true; change(); } });
qc.addEventListener('click', function () { qi.value = ''; state.q = ''; qc.hidden = true; change(); qi.focus(); });
sortEl.addEventListener('change', function () { state.sort = sortEl.value; change(); });
function readFilters() {
  state.types = $$('input[name=type]:checked').map(function (i) { return i.value; });
  state.brands = $$('input[name=brand]:checked').map(function (i) { return i.value; });
  var c = $('input[name=compat]:checked'); state.compat = c ? c.value : '';
  state.stock = $('input[name=stock]').checked;
  state.min = minEl.value === '' || isNaN(+minEl.value) ? null : Math.max(0, +minEl.value);
  state.max = maxEl.value === '' || isNaN(+maxEl.value) ? null : Math.max(0, +maxEl.value);
}
fEl.addEventListener('change', function (e) { if (e.target.matches('input')) { readFilters(); change(); } });
var ptimer = 0;
[minEl, maxEl].forEach(function (el) { el.addEventListener('input', function () { clearTimeout(ptimer); ptimer = setTimeout(function () { readFilters(); change(); }, 300); }); });
root.addEventListener('change', function (e) { if (e.target.matches('[data-rap-mine-in]')) { state.mine = e.target.checked; change(); } });
function clearAll() { state = { q: '', types: [], compat: '', brands: [], min: null, max: null, stock: false, sort: 'rel', mine: false }; change(); }
root.addEventListener('click', function (e) {
  var t = e.target.closest('[data-rm],[data-rap-clear],[data-rap-showmore],[data-rap-open],[data-rap-close]');
  if (!t) return;
  if (t.matches('[data-rap-clear]')) { clearAll(); return; }
  if (t.matches('[data-rap-showmore]')) { shown += STEP; render(); var f = grid.children[shown - STEP]; if (f) { var a = f.querySelector('a[href]'); if (a) a.focus({ preventScroll: false }); } return; }
  if (t.matches('[data-rap-open]')) { openDrawer(); ensure().then(function () { render(); }).catch(function () {}); return; }
  if (t.matches('[data-rap-close]')) { closeDrawer(); return; }
  var k = t.dataset.rm.split(':'), v = k[1];
  if (k[0] === 'q') state.q = ''; else if (k[0] === 'type') state.types = state.types.filter(function (x) { return x !== v; });
  else if (k[0] === 'brand') state.brands = state.brands.filter(function (x) { return x !== v; });
  else if (k[0] === 'compat') state.compat = ''; else if (k[0] === 'price') { state.min = null; state.max = null; }
  else if (k[0] === 'stock') state.stock = false; else if (k[0] === 'mine') state.mine = false;
  change();
  var nx = actEl.querySelector('button'); (nx || qi).focus();
});
backEl.addEventListener('click', closeDrawer);
var lastFocus = null, mq = window.matchMedia('(width < 990px)');
function openDrawer() { if (!mq.matches) return; lastFocus = document.activeElement; fEl.classList.add('is-open'); backEl.hidden = false; html.classList.add('rap-lock'); openBtn.setAttribute('aria-expanded', 'true'); fEl.setAttribute('role', 'dialog'); fEl.setAttribute('aria-modal', 'true'); fEl.setAttribute('aria-labelledby', 'rap-ft'); var c = $('.rap__x', fEl); if (c) c.focus(); }
function closeDrawer() { if (!fEl.classList.contains('is-open')) return; fEl.classList.remove('is-open'); backEl.hidden = true; html.classList.remove('rap-lock'); openBtn.setAttribute('aria-expanded', 'false'); fEl.removeAttribute('role'); fEl.removeAttribute('aria-modal'); fEl.removeAttribute('aria-labelledby'); (lastFocus || openBtn).focus(); }
mq.addEventListener && mq.addEventListener('change', function () { if (!mq.matches && fEl.classList.contains('is-open')) closeDrawer(); });
document.addEventListener('keydown', function (e) {
  if (!fEl.classList.contains('is-open')) return;
  if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
  if (e.key === 'Tab') { var f = $$('button,input,select,a[href]', fEl).filter(function (x) { return !x.disabled && x.getClientRects().length; }); if (!f.length) return; if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); } }
});
/* preload the catalog on the first sign of interest */
var warmed = false;
function warm() { if (warmed) return; warmed = true; ensure().then(function () { render(); }).catch(function () {}); }
['focusin', 'pointerover', 'touchstart'].forEach(function (ev) { $('[data-rap-tools]').addEventListener(ev, warm, { passive: true, once: false }); fEl.addEventListener(ev, warm, { passive: true }); });
document.addEventListener('ripost:bikes', function () { renderMine(); if (state.mine) change(); });

/* ---------- boot ---------- */
var wide = window.matchMedia('(width > 750px)'); var setPh = function () { qi.placeholder = wide.matches ? qi.dataset.long : 'Produit, vélo ou marque…'; }; setPh(); wide.addEventListener && wide.addEventListener('change', setPh);
state = parseUrl();
if (qi) { syncInputs(); }
var tries = 0;
(function waitBikes() { if (window.RipostBikes) { renderMine(); if (state.mine) ensureBikes().then(function () { renderMine(); render(); }).catch(function () {}); return; } if (++tries < 40) setTimeout(waitBikes, 100); })();
if (!isDefault(state)) { warmed = true; render(); ensure().then(function () { renderMine(); render(); }).catch(function () { fail(); }); }
else html.classList.remove('rap-pending');
})();
